export default {
    "fr": {
        "account": "mon-compte"
    },
    "en": {
        "account": "account"
    }
}
